import React from 'react';

export const DownloadWhiteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
  >
    <path
      d="M0.75 18.5044H14.2477C14.6619 18.5044 14.9977 18.8402 14.9977 19.2544C14.9977 19.6341 14.7155 19.9479 14.3494 19.9975L14.2477 20.0044H0.75C0.33579 20.0044 0 19.6686 0 19.2544C0 18.8747 0.28215 18.5609 0.64823 18.5112L0.75 18.5044H14.2477H0.75ZM7.3834 0.00672996L7.5 0C8.0128 0 8.4355 0.38604 8.4933 0.88338L8.5 1V13.59L11.7941 10.2972C12.1546 9.93681 12.7218 9.90911 13.1141 10.2142L13.2083 10.2974C13.5687 10.6579 13.5964 11.2251 13.2913 11.6174L13.2081 11.7116L8.2105 16.7082C7.8502 17.0684 7.2833 17.0963 6.891 16.7917L6.7968 16.7086L1.79338 11.712C1.40259 11.3217 1.40215 10.6886 1.79241 10.2978C2.15265 9.93701 2.71986 9.90891 3.11236 10.2137L3.20662 10.2968L6.5 13.585V1C6.5 0.48717 6.886 0.0645 7.3834 0.00672996L7.5 0L7.3834 0.00672996Z"
      fill="white"
    />
  </svg>
);
